import React from "react";
import styled from "styled-components";

const SwitchContent = styled.div`
  position: relative;
  display: flex;
  width: 45px;
  height: 20px;
  border-radius: 15px;
  margin-left: auto;
  cursor: pointer;

  &:before{
    content: "";
    display: block;
    position: absolute;
    left: ${props => props.inputValue ? "calc(100% - 18px);" : "2px;" };
    top: 2px;
    width: 16px;
    height: 16px;
    background-color: #fff;
    border-radius: 50%;
    transition: .2s;
  }

  background-color: ${props => props.inputValue ? "#44ADF8" : "#C4C4C4" };
`;

const Switch = ({ value, onClick }) => (
  <SwitchContent inputValue={value} onClick={onClick}>
    <input type="radio" checked={value} hidden />
  </SwitchContent>
)

export default Switch;